<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";
import VAppLink from "@magnit/core/src/components/VAppLink/VAppLink.vue";
import VButton from "@magnit/core/src/components/VButton/VButton.vue";
import type { IEmptyEmits, IEmptyProps } from "./VEmpty.types";

defineProps<IEmptyProps>();

const emit = defineEmits<IEmptyEmits>();
</script>

<template>
  <div class="pl-empty-state">
    <component :is="icon" v-if="icon" />
    <img v-if="iconUrl" :src="iconUrl" alt="" />
    <div class="pl-empty-state__content">
      <VText
        v-if="title"
        tag="div"
        font="headline-small"
        class="pl-empty-state__title"
        ><span v-html="title"></span
      ></VText>
      <VText v-if="description" tag="div" class="pl-empty-state__description"
        ><span v-html="description"></span
      ></VText>
    </div>
    <div
      v-if="primaryButton || secondaryButton"
      class="pl-empty-state__buttons"
    >
      <component
        :is="primaryButton.url ? VAppLink : 'div'"
        v-if="primaryButton"
        :to="primaryButton.url"
        class="pl-empty-state__buttons__item"
        @click="emit('click:primary')"
      >
        <VButton full-width tag="span">
          {{ primaryButton.title }}
        </VButton>
      </component>
      <component
        :is="secondaryButton.url ? VAppLink : 'div'"
        v-if="secondaryButton"
        :to="secondaryButton.url"
        class="pl-empty-state__buttons__item"
        @click="emit('click:secondary')"
      >
        <VButton full-width theme="secondary" tag="span">
          {{ secondaryButton.title }}
        </VButton>
      </component>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.pl-empty-state {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-bottom: var(--pl-unit-x4);
  gap: var(--pl-unit-x4);

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--pl-unit-x2);
    padding: 0 var(--pl-unit-x3);
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    gap: var(--pl-unit-x3);
    padding-top: var(--pl-unit-x4);
    width: 100%;
  }
}
</style>
